module.exports = __webpack_public_path__ + "img/mastercard.bb3c6348.svg";